import React, { useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";
import "../../assets/scss/datatables.scss";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";

import { useDeleteAccount, useGetAccountById } from "hooks/useAccounts";

import { useNavigate, useParams } from "react-router-dom";
import { AccountCard, AccountTransactions } from "./components";
import DeleteModal from "Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { accounts } from "./constants";
import { toast } from "react-toastify";
import { AppRoutes } from "../../constants";

const AccountDetails = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetAccountById(id || "");
  const { mutate } = useDeleteAccount();
  const navigate = useNavigate();
  //meta title
  document.title = "Pappermap | Account Details";
  const [isMenu, setIsMenu] = useState<boolean>(false);
  const [resource, setResource] = useState<any>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<any>("1");

  const toggleTab = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleMenu = () => {
    setIsMenu(!isMenu);
  };

  const handleEditAccountClick = (id: any) => {
    navigate(`/edit-account/${id}`);
  };

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteAccount = () => {
    if (resource.id) {
      mutate(resource.id, {
        onSuccess: () => {
          toast.success("Account deleted successfully.");
          navigate(AppRoutes.ACCOUNTS);
        },
      });
      setDeleteModal(false);
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Account" breadcrumbItem="Account Details" />

          <Row>
            <Col md="6" lg="6" xl="4">
              <AccountCard
                account={data}
                isMenu={isMenu}
                toggleMenu={toggleMenu}
                onEditClick={() => handleEditAccountClick(data.id)}
                onDeleteClick={() => onClickDelete(data)}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              {!isEmpty(accounts) && (
                <AccountTransactions
                  walletHistory={accounts[0].price}
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteAccount}
        onCloseClick={() => setDeleteModal(false)}
      />
    </React.Fragment>
  );
};

export default AccountDetails;
